import { gsap } from 'gsap';
import { breakpoints } from '../helpers/constants';
const footer = () => {
  const $footer = document.querySelector('.footer-section-content');
  if (!$footer) return;
  const $footerCols = $footer.querySelectorAll('.footer-section-content-column');
  const $footerHeadlines = $footer.querySelectorAll('.frame-header');
  const slideDown = $el => {
    const $content = $el.querySelectorAll('p, li');
    gsap.timeline().to($el, {
      duration: 1.2,
      delay: 0.1,
      height: 'auto',
      ease: 'power4.out'
    }).to($content, {
      x: 0,
      duration: 0.6,
      opacity: 1,
      ease: 'power4.out',
      stagger: 0.3
    }, 0.3);
  };
  const slideUp = $el => {
    const $content = $el.querySelectorAll('p, li');
    gsap.timeline().to($el, {
      delay: 0.1,
      duration: 1.2,
      ease: 'power4.out',
      height: 0
    }).to($content, {
      x: -50,
      duration: 0.6,
      opacity: 0,
      ease: 'power4.out',
      stagger: 0.3
    }, 0);
  };
  const toggleAll = target => {
    $footerHeadlines.forEach($header => {
      if (target.isEqualNode($header)) return;
      $header.classList.remove('toggled');
      slideUp($header.nextElementSibling);
    });
  };
  function navColCollapse() {
    $footerCols.forEach($col => {
      const $headline = $col.querySelector('.frame-header');
      let $content = $col.querySelector('.contentCollapse');
      if (!$headline) return;
      if (window.innerWidth < breakpoints.md) {
        if (!$content) $($headline).nextAll().wrapAll('<div class="contentCollapse"></div>');
        $content = $col.querySelector('.contentCollapse');
        $headline.classList.add('toggle');
        $headline.classList.remove('toggled');
        $headline.onclick = () => {
          $headline.classList.toggle('toggled');
          if ($headline.classList.contains('toggled')) {
            slideDown($content);
          } else {
            slideUp($content);
          }
          toggleAll($headline);
        };
        slideUp($content);
      } else {
        $headline.classList.remove('toggle');
        $headline.onclick = () => false;
        if ($content) $($content).children().unwrap();
      }
    });
  }
  navColCollapse();
  document.addEventListener('containerResize', navColCollapse);
};
export default footer;